import { mapGetters } from 'vuex';
import { CART, MENU_OPTION_EXCEPTIONS } from '@/stores/defs';
import { camelCase, map, flatMap } from 'lodash';

const checkoutPriceMixin = {
	computed: {
		...mapGetters({
			getItemPriceInCart: CART.GET_ITEM_PRICE,
			totals: CART.GET_TOTALS,
			getOptionExceptions: MENU_OPTION_EXCEPTIONS.GET_FOR_ITEM,
		}),
		streamLinedTotals() {
			const streamLinedTotal = {};
			let grandTotal = 0;
			Object.keys(this.totals).forEach(key => {
				const cKey = camelCase(key);

				if (['subTotal', 'tax', 'discount', 'service_charge'].includes(key)) {
					// values to be subtracted from total
					if (['refund', 'discount'].includes(key)) {
						streamLinedTotal[cKey] = this.totals[key] * -1;
					} else {
						streamLinedTotal[cKey] = this.totals[key];
					}
					grandTotal += streamLinedTotal[cKey];
				}
			});
			streamLinedTotal.total = grandTotal;
			return streamLinedTotal;
		},
	},
	methods: {
		getItemTotal(itemIndex) {
			return this.getItemPriceInCart(itemIndex);
		},
		getItemOptionExceptions(items) {
			const itemIds = flatMap(items, 'id');
			const exceptions = map(itemIds, (id) => {
				const itemExceptions = this.getOptionExceptions(id);
				if (itemExceptions) {
					return itemExceptions;
				}
				return null;
			});
			return exceptions;
		},
	},
};

export default checkoutPriceMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/checkoutPricesMixin.js